export enum InvoiceStatus {
    NotPaid,
    Paid,
    PartiallyPaid
}